import { render, staticRenderFns } from "./stat-content.vue?vue&type=template&id=28ff399c&scoped=true&"
import script from "./stat-content.vue?vue&type=script&lang=js&"
export * from "./stat-content.vue?vue&type=script&lang=js&"
import style0 from "./stat-content.vue?vue&type=style&index=0&id=28ff399c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff399c",
  null
  
)

export default component.exports